import { WizardModel } from "@/shared/Wizard/models/WizardModel";
import { WizardStep } from "@/shared/Wizard/models/WizardStep";
import { AnalysisWizardSharedModel } from "../models/AnaylsisWizardSharedModel";


export class AnalysisWizardService {

    public static async runAsyncTaskWithLoading<T, A extends any[]>(
        message: string = "Loading..",
        wizardModel?: WizardModel<
            WizardStep<AnalysisWizardSharedModel, string | number>,
            AnalysisWizardSharedModel
        >,
        fn?: (...args: A) => T | Promise<T>,
        ...args: A
    ): Promise<T | undefined> {

        if (!fn) return Promise.resolve(undefined);

        const step = wizardModel?.activeStep;
        if (step) {
            step.loadingMessage = message;
            step.isLoading = true;
        }

        try {
            const task = await Promise.resolve(fn(...args));
            return task;
        } finally {
            if (step) {
                step.isLoading = false;
                step.loadingMessage = undefined;
            }
        }
    }

}